import { Toggle, Modal, Button, Loader } from "rsuite";
import { useState } from "react";
import { ApiSchemaCompany } from "../models/api";
import { ApiCompany } from "../core/apis";
import { useDispatch } from "react-redux";
import { ActionsCompanyTable } from "../core/redux";

export const GPSCheckInToggleForCompany = ({
  company,
}: {
  company: ApiSchemaCompany;
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleToggle = async () => {
    setIsLoading(true);
    const response = await ApiCompany.ToggleGPSCheckIn(
      company,
      !company.isGpsCheckInEnable
    );
    setIsLoading(false);
    handleClose();
    if (response.isSuccess) {
      dispatch(ActionsCompanyTable.setRefetch(true));
    }
  };

  return (
    <>
      {isLoading ? (
        <Loader size="sm" />
      ) : (
        <Toggle
          size="sm"
          onChange={handleOpen}
          disabled={isLoading}
          checked={company.isGpsCheckInEnable}
        />
      )}
      <Modal open={open} onClose={handleClose}>
        <Modal.Body>
          <p>
            Turn GPS Check In {company.isGpsCheckInEnable ? "off" : "on"} for{" "}
            {company.name}?
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            loading={isLoading}
            appearance="primary"
            onClick={handleToggle}
          >
            Ok
          </Button>
          <Button
            onClick={handleClose}
            disabled={isLoading}
            appearance="subtle"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
